module.exports = __webpack_public_path__ + "img/vps_back.ab5fce9.png";